import * as moment from 'moment';
import {
  FZW_DATE_FORMAT,
  FZW_UI_DATETIME_FORMAT,
  FZW_UI_DATE_FORMAT,
} from '@bp2s/core/consts/date-format.consts';

const HYPHEN_FORMATS = [FZW_DATE_FORMAT.DATE_FORMAT, FZW_DATE_FORMAT.DATETIME_FORMAT, FZW_DATE_FORMAT.DATETIME_WITH_AMPM_FORMAT];

/*****************************************************************************/
/*                Helpers to avoid code complexity warnings                  */
/*****************************************************************************/

function formatMoment(obj: moment.Moment, fmt: string, defaultValue: string): string {
  let ret = defaultValue;
  if (obj.isValid()) {
    ret = obj.format(fmt);
  }
  return ret;
}

function toGenericStringDate(arg: string | moment.Moment, fmt: string, slahsFmt: string, hyphenFmt: string[], defaultValue: string): string {
  if (arg) {
    if (moment.isMoment(arg)) {
      return formatMoment(arg, fmt, defaultValue);
    } else if (arg.includes('-')) {
      const obj = moment(arg, hyphenFmt, true);
      return formatMoment(obj, fmt, defaultValue);
    } else if (arg.includes('/')) {
      const obj = moment(arg, slahsFmt, true);
      return formatMoment(obj, fmt, defaultValue);
    }
  }
  return defaultValue;
}

function toStringDate(arg: string | moment.Moment, fmt: string, defaultValue: string): string {
  return toGenericStringDate(arg, fmt, FZW_UI_DATE_FORMAT, HYPHEN_FORMATS, defaultValue);
}
function toStringDateTime(arg: string | moment.Moment, fmt: string, defaultValue: string): string {
  return toGenericStringDate(arg, fmt, FZW_UI_DATETIME_FORMAT, HYPHEN_FORMATS, defaultValue);
}
function toGenericMomentDate(arg: string | moment.Moment, slashFmt: string, hyphenFmt: string[]): moment.Moment {
  let ret = null;
  if (!arg) {
    return null;
  }
  if (!moment.isMoment(arg)) {
    if (arg.includes('/')) {
      ret = moment(arg, slashFmt, true);
    } else if (arg.includes('-')) {
      ret = moment(arg, hyphenFmt, true);
    }
  } else {
    ret = arg;
  }
  if (!ret || !ret.isValid()) {
    ret = null;
  }
  return ret;
}
/*****************************************************************************/
/*                            End Helpers                                    */
/*****************************************************************************/



export class DateUtil {

  static toUIDate(arg: string | moment.Moment, defaultValue: string=''): string {
    return toStringDate(arg, FZW_UI_DATE_FORMAT, defaultValue);
  }
  static toUIDateTime(arg: string | moment.Moment, defaultValue: string=''): string {
    return toStringDateTime(arg, FZW_UI_DATETIME_FORMAT, defaultValue);
  }

  static toDBDate(arg: string | moment.Moment): string {
    return toStringDate(arg, FZW_DATE_FORMAT.DATE_FORMAT, null);
  }
  static toDBDateTime(arg: string | moment.Moment): string {
    return toStringDateTime(arg, FZW_DATE_FORMAT.DATETIME_FORMAT, null);
  }

  static toMomentDate(arg: string | moment.Moment): moment.Moment {
    return toGenericMomentDate(arg, FZW_UI_DATE_FORMAT, HYPHEN_FORMATS);
  }
  static toMomentDateTime(arg: string | moment.Moment): moment.Moment {
    return toGenericMomentDate(arg, FZW_UI_DATETIME_FORMAT, HYPHEN_FORMATS);
  }

}
